import { APIConfig } from 'src/config';
import { getRouteTimeRange } from 'src/util/time';

// Shared with the initial-load `prepareVariables` in `src/routes/index.jsx` so the
// retry page size can never silently diverge from the initial load page size.
export const PORTFOLIO_USER_MEMBER_LIST_PAGE_SIZE = 100;

/**
 * Builds the retry variables used to retry the portfolio user member list.
 * Mirrors the existing `prepareVariables` in `src/routes/index.jsx`, which
 * honours `tz` and falls back to `APIConfig().DEFAULT_TIMEZONE`.
 * @param {object} props - Found-relay route props.
 * @returns {object|null} Retry variables, or null when the portfolio is missing.
 */
function buildPortfolioUserMemberListRetryVariables(props) {
  const uuid = props?.match?.params?.uuid;
  if (!uuid) {
    return null;
  }

  const { start, finish, tz } = props?.match?.location?.query || {};
  const timeZone = tz || APIConfig().DEFAULT_TIMEZONE;
  const { s: startTime, f: finishTime } = getRouteTimeRange(start, finish, timeZone);

  return {
    uuid,
    count: PORTFOLIO_USER_MEMBER_LIST_PAGE_SIZE,
    start: startTime.toSeconds(),
    finish: finishTime.toSeconds(),
  };
}

export default buildPortfolioUserMemberListRetryVariables;
